import {React, observer, observable, IDisposer, useEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {ChangeLogClosableChip, ChangeLogFlexLayoutTabStore, ContentTitleBarItem, ISortWithOrder, useChangeLogFlexLayoutTabStore, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {action, computed} from 'mobx'
import {_} from '../../shared/components/3rd-party'
import * as css from './ChangeLogTitleBarItem.css'

/// region Store

export class ChangeLogTitleBarItemStore extends VipLocalStore {
  constructor(stores: StoresInstance, public rootStore: ChangeLogFlexLayoutTabStore, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  @observable open: boolean = false
  // @observable selected = observable.map<string, WorkspaceFieldConfig>({}, {deep: false})

  @action onOpen = () => {
    this.open = true
  }

  @action onClose = () => {
    this.open = false
  }

  get applied() {
    return this.props.applied
  }

  @action onSelectMenuItem = (key, field, selectedField) => {
    const {selected, props: {onClickMenuItem}, rootStore, rootStore: {selected: selectedFields, filters}} = this,
      index = selected.findIndex(s => ((s.type !== undefined && s.type === field.type) || (s.field !== undefined && s.field === field.field)))
    if (_.isFunction(onClickMenuItem)) {
      onClickMenuItem({key: field?.type ?? field?.field, field, selectedField})
    } else {
      if (selectedField && field.field !== selectedField.field && index === -1) {
        const selectIndex = selectedFields.findIndex(s => ((s.type !== undefined && s.type === selectedField.type) || s.field === selectedField.field))
        selectedFields.splice(selectIndex, 1, field)
        delete filters[selectedField.field ?? selectedField.type]
        this.rootStore.refetch()
      } else {
        const type = field.field ?? field.type
        if (index > -1) {
          selectedFields.splice(index, 1)
          delete filters[type]
        } else {
          selectedFields.push(field)
          if (!filters[type]) {
            filters[type] = {
              selected: [],
              field,
              subSelected: {value: []},
              excluded: {value: []}
            }
          }
        }
        this.stores.catalog.settings.changelog.filterSelected = selectedFields
      }
    }
  }

  @computed get title() {
    return this.props.title
  }

  @computed get chipIcon() {
    return this.props.chipIcon
  }

  @computed get selected() {
    const {rootStore, props: {feature}} = this
    return feature === 'filter' ? rootStore.selected : _.map(rootStore.sortWithOrder, s => s.field)
  }

  @computed get sortWithOrder(): Array<ISortWithOrder> {
    const {rootStore} = this
    return rootStore.sortWithOrder
  }

  @computed get indexes() {
    const {rootStore: {filters}} = this,
      ws = filters['workspace']

    if (!!ws) {
      return ws.selected.map(s => s.catalog.index)
    }
    return []
  }
}

export const ChangeLogTitleBarItemStoreContext = React.createContext<ChangeLogTitleBarItemStore>(null)
export const useChangeLogTitleBarItemStore = () => React.useContext(ChangeLogTitleBarItemStoreContext)

/// endregion

/// region Components

interface MyProps {
  title: string
  className?: string
  chipIcon?: any
  feature?: 'filter' | 'sort'
  onClickMenuItem?: ({key: string, field, selectedField}) => void
  onClear?: Function
  applied?: boolean
}

const ChangeLogTitleBarItemContent = observer<any>(function ChangeLogTitleBarItemContent() {
  const {selected, onSelectMenuItem, title, sortWithOrder, props: {feature, onClear}, indexes} = useChangeLogTitleBarItemStore()

  return (
    <ContentTitleBarItem title={title} onSelectMenuItem={onSelectMenuItem} onClear={onClear} selected={selected} sortWithOrder={sortWithOrder} feature={feature} indexes={indexes}/>
  )
})

export const ChangeLogTitleBarItem = observer<MyProps>(function ChangeLogTitleBarItem({className, ...props}) {
  const rootStore = useChangeLogFlexLayoutTabStore(),
    obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new ChangeLogTitleBarItemStore(stores, rootStore, obsProps)),
    {open, onOpen, onClose, title, chipIcon, applied} = store

  // useEffect(() => store.registerEffects(), [])

  return (
    <ChangeLogTitleBarItemStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <Popover2
          usePortal={false}
          captureDismiss
          interactionKind={'click'}
          onOpening={onOpen}
          onClosing={onClose}
          content={<ChangeLogTitleBarItemContent/>}
        ><ChangeLogClosableChip title={title} applied={applied} icon={chipIcon} onClick={open ? onClose : onOpen} active={open}/></Popover2>
      </div>
    </ChangeLogTitleBarItemStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/ChangeLogTitleBarItem.tsx